import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import ToastPlugin from 'vue-toast-notification';


createApp(App).use(store).use(router).use(ToastPlugin, {
    position: 'Bottom'
}).mount('#app')
